<div class="form-page">

    <div class="page-header justify-content-between">
        <button class="back-btn" (click)="goBack()">
            <span class="back-arrow">&#8592;</span> Back
        </button>
        <div class="header-actions">
            <p-button label="Cancel" variant="text" severity="secondary" (click)="onCancel()" />
            <p-button [label]="editMode ? 'Save' : 'Save'" severity="primary" [disabled]="loading" (click)="onSubmit()" />
        </div>
    </div>

    <form [formGroup]="modelForm" [class.form-submitted]="isSubmitted" class="mb-3">
        <div class="form-columns">

                <!-- Left: General info -->
                <div class="form-col form-col--card">
                    <h3 class="col-title">General info</h3>

                    <!-- Image upload -->
                    <div class="field-block">
                        <span class="field-label">Image<span class="field-required">*</span></span>
                        <div class="image-upload-area">
                            @if (imagePreview) {
                            <img [src]="imagePreview" alt="Preview" class="image-preview" />
                            <p-button  label="Remove" variant="outlined" severity="danger" size="small" (onClick)="removeImage()" />
                            } @else if (editMode && modelData.imageUrl) {
                            <img [src]="modelData.imageUrl" alt="Current" class="image-preview" />
                            <p-button label="Remove" variant="outlined" severity="danger" size="small" (onClick)="removeImage()" />
                            } @else {
                            <p-fileUpload #fileUpload name="image" (onSelect)="onImageSelect($event)" accept="image/*" [showUploadButton]="false" [showCancelButton]="false">
                                <ng-template #header></ng-template>
                                <ng-template #file></ng-template>
                                <ng-template #empty>
                                    <div class="upload-placeholder">
                                        <p-button label="Browse" variant="outlined" severity="info" size="small" (click)="openBrowser()" />
                                        <p class="upload-hint">Or drag and drop files</p>
                                    </div>
                                </ng-template>
                            </p-fileUpload>
                            }
                        </div>
                        @if ((fileError || isSubmitted) && !editMode && !file) {
                        <small class="field-error">This field is required</small>
                        }
                    </div>

                    <!-- Model + Model marker -->
                    <div class="field-row">
                        <div class="field-block">
                            <label for="name" class="field-label">Model<span class="field-required">*</span></label>
                            <input id="name" formControlName="name" type="text" pInputText placeholder="Enter" class="field-input" />
                            @if (modelForm.get('name')?.touched || isSubmitted) {
                            <small class="field-error">
                                @if (modelForm.get('name')?.errors?.['required']) { This field is required }
                                @if (formErrors['name']) { {{formErrors['name']}} }
                            </small>
                            }
                        </div>
                        <div class="field-block">
                            <label for="maker" class="field-label">Model marker<span class="field-required">*</span></label>
                            <input id="maker" formControlName="maker" type="text" pInputText placeholder="Enter" class="field-input" />
                            @if (modelForm.get('maker')?.touched || isSubmitted) {
                            <small class="field-error">
                                @if (modelForm.get('maker')?.errors?.['required']) { This field is required }
                                @if (formErrors['maker']) { {{formErrors['maker']}} }
                            </small>
                            }
                        </div>
                    </div>

                    <!-- Body type + Rental type -->
                    <div class="field-row">
                        <div class="field-block">
                            <label for="bodyType" class="field-label">Body type<span class="field-required">*</span></label>
                            <p-select id="bodyType" class="field-select" formControlName="bodyType" [options]="bodyTypeOptions" placeholder="Select"></p-select>
                            @if (modelForm.get('bodyType')?.touched || isSubmitted) {
                            <small class="field-error">
                                @if (modelForm.get('bodyType')?.errors?.['required']) { This field is required }
                            </small>
                            }
                        </div>
                        <div class="field-block">
                            <label for="rentalType" class="field-label">Rental type<span class="field-required">*</span></label>
                            <p-select id="rentalType" class="field-select" formControlName="rentalType" [options]="rentalTypeOptions" placeholder="Select"></p-select>
                            @if (modelForm.get('rentalType')?.touched || isSubmitted) {
                            <small class="field-error">
                                @if (modelForm.get('rentalType')?.errors?.['required']) { This field is required }
                            </small>
                            }
                        </div>
                    </div>

                    <!-- Fuel type + Fuel level unit -->
                    <div class="field-row">
                        <div class="field-block">
                            <label for="fuelType" class="field-label">Fuel type<span class="field-required">*</span></label>
                            <p-select id="fuelType" class="field-select" formControlName="fuelType" [options]="fuelTypeOptions" placeholder="Select"></p-select>
                            @if (modelForm.get('fuelType')?.touched || isSubmitted) {
                            <small class="field-error">
                                @if (modelForm.get('fuelType')?.errors?.['required']) { This field is required }
                            </small>
                            }
                        </div>
                        <div class="field-block">
                            <label for="fuelLevelUnit" class="field-label">Fuel level unit<span class="field-required">*</span></label>
                            <p-select id="fuelLevelUnit" class="field-select" formControlName="fuelLevelUnit" [options]="fuelLevelUnitOptions" placeholder="Select"></p-select>
                            @if (modelForm.get('fuelLevelUnit')?.touched || isSubmitted) {
                            <small class="field-error">
                                @if (modelForm.get('fuelLevelUnit')?.errors?.['required']) { This field is required }
                            </small>
                            }
                        </div>
                    </div>

                    <!-- Transmission type + Seat Capacity -->
                    <div class="field-row">
                        <div class="field-block">
                            <label for="transmissionType" class="field-label">Transmission Type<span class="field-required">*</span></label>
                            <p-select id="transmissionType" class="field-select" formControlName="transmissionType" [options]="transmissionTypeOptions" placeholder="Select"></p-select>
                            @if (modelForm.get('transmissionType')?.touched || isSubmitted) {
                            <small class="field-error">
                                @if (modelForm.get('transmissionType')?.errors?.['required']) { This field is required }
                            </small>
                            }
                        </div>
                        <div class="field-block">
                            <label for="seats" class="field-label">Seat Capacity<span class="field-required">*</span></label>
                            <p-inputnumber class="field-number" inputStyleClass="field-input" formControlName="seats" placeholder="Enter" inputId="seats" [min]="2" [max]="12" />
                            @if (modelForm.get('seats')?.touched || isSubmitted) {
                            <small class="field-error">
                                @if (modelForm.get('seats')?.errors?.['required']) { This field is required }
                            </small>
                            }
                        </div>
                    </div>

                    <!-- Horse Power + Max Speed -->
                    <div class="field-row">
                        <div class="field-block">
                            <label for="horsePower" class="field-label">Horse Power<span class="field-required">*</span></label>
                            <p-inputnumber class="field-number" inputStyleClass="field-input" formControlName="horsepower" placeholder="Enter" inputId="horsePower" [min]="0" />
                            @if (modelForm.get('horsepower')?.touched || isSubmitted) {
                            <small class="field-error">
                                @if (modelForm.get('horsepower')?.errors?.['required']) { This field is required }
                            </small>
                            }
                        </div>
                        <div class="field-block">
                            <label for="maxSpeed" class="field-label">Max Speed<span class="field-required">*</span></label>
                            <p-inputnumber class="field-number" inputStyleClass="field-input" formControlName="maxSpeed" placeholder="Enter" inputId="maxSpeed" [min]="0" />
                            @if (modelForm.get('maxSpeed')?.touched || isSubmitted) {
                            <small class="field-error">
                                @if (modelForm.get('maxSpeed')?.errors?.['required']) { This field is required }
                            </small>
                            }
                        </div>
                    </div>

                    <!-- Tank Capacity + km Per Liter -->
                    <div class="field-row">
                        <div class="field-block">
                            <label for="tankCapacity" class="field-label">Tank Capacity<span class="field-required">*</span></label>
                            <p-inputnumber class="field-number" inputStyleClass="field-input" formControlName="tankCapacity" placeholder="Enter" inputId="tankCapacity" [min]="0" />
                            @if (modelForm.get('tankCapacity')?.touched || isSubmitted) {
                            <small class="field-error">
                                @if (modelForm.get('tankCapacity')?.errors?.['required']) { This field is required }
                            </small>
                            }
                        </div>
                        <div class="field-block">
                            <label for="kmPerLiter" class="field-label">km Per Liter<span class="field-required">*</span></label>
                            <p-inputnumber class="field-number" inputStyleClass="field-input" formControlName="kmPerLiter" placeholder="Enter" inputId="kmPerLiter" [min]="0" [minFractionDigits]="2" [maxFractionDigits]="5" />
                            @if (modelForm.get('kmPerLiter')?.touched || isSubmitted) {
                            <small class="field-error">
                                @if (modelForm.get('kmPerLiter')?.errors?.['required']) { This field is required }
                            </small>
                            }
                        </div>
                    </div>

                    <!-- 0-100 km/h full width -->
                    <div class="field-block">
                        <label for="zeroToHundred" class="field-label">0–100 km/h<span class="field-required">*</span></label>
                        <p-inputnumber class="field-number" inputStyleClass="field-input" formControlName="zeroToHundred" placeholder="Enter" inputId="zeroToHundred" [min]="0" [minFractionDigits]="2" [maxFractionDigits]="5" />
                        @if (modelForm.get('zeroToHundred')?.touched || isSubmitted) {
                        <small class="field-error">
                            @if (modelForm.get('zeroToHundred')?.errors?.['required']) { This field is required }
                        </small>
                        }
                    </div>

                    <!-- Features -->
                    <div class="field-block">
                        <label for="features" class="field-label">Features</label>
                        <p-autocomplete class="w-full" inputId="features" formControlName="features" multiple fluid [typeahead]="false" />
                    </div>
                </div>

                <!-- Right: Pricing & add-ons -->
                <div class="form-col form-col--card">
                    <h3 class="col-title">Pricing & add-ons</h3>

                    <div class="field-block">
                        <label for="startingFee" class="field-label">Starting fee<span class="field-required">*</span></label>
                        <p-inputnumber class="field-number" inputStyleClass="field-input" formControlName="startingFee" placeholder="Enter" inputId="startingFee" [min]="0" />
                        @if (modelForm.get('startingFee')?.touched || isSubmitted) {
                        <small class="field-error">
                            @if (modelForm.get('startingFee')?.errors?.['required']) { This field is required }
                        </small>
                        }
                    </div>

                    <div class="field-block">
                        <label for="pricingPlanIds" class="field-label">Pricing plan<span class="field-required">*</span></label>
                        <p-multiSelect class="w-full field-select" formControlName="pricingPlanIds" [options]="pricingPlansList()" placeholder="Select" optionLabel="name" optionValue="id" [showClear]="true"></p-multiSelect>
                        @if (modelForm.get('pricingPlanIds')?.touched || isSubmitted) {
                        <small class="field-error">
                            @if (modelForm.get('pricingPlanIds')?.errors?.['required']) { This field is required }
                        </small>
                        }
                    </div>

                    <div class="field-block">
                        <label for="mileagePlanIds" class="field-label">Mileage Plan<span class="field-required">*</span></label>
                        <p-multiSelect class="w-full field-select" formControlName="mileagePlanIds" [options]="mileagePlansList()" placeholder="Select" optionLabel="name" optionValue="id" [showClear]="true"></p-multiSelect>
                        @if (modelForm.get('mileagePlanIds')?.touched || isSubmitted) {
                        <small class="field-error">
                            @if (modelForm.get('mileagePlanIds')?.errors?.['required']) { This field is required }
                        </small>
                        }
                    </div>

                    <div class="field-block">
                        <label for="tempHold" class="field-label">Temporary hold<span class="field-required">*</span></label>
                        <p-inputnumber class="field-number" inputStyleClass="field-input" formControlName="tempHold" placeholder="Enter" inputId="tempHold" [min]="0" />
                        @if (modelForm.get('tempHold')?.touched || isSubmitted) {
                        <small class="field-error">
                            @if (modelForm.get('tempHold')?.errors?.['required']) { This field is required }
                        </small>
                        }
                    </div>

                    <div class="field-block">
                        <label for="overageRatePerKm" class="field-label">Rate per KM<span class="field-required">*</span></label>
                        <p-inputnumber class="field-number" inputStyleClass="field-input" formControlName="overageRatePerKm" placeholder="Enter" inputId="overageRatePerKm" [min]="0" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="2" />
                        @if (modelForm.get('overageRatePerKm')?.touched || isSubmitted) {
                        <small class="field-error">
                            @if (modelForm.get('overageRatePerKm')?.errors?.['required']) { This field is required }
                        </small>
                        }
                    </div>
                </div>

        </div>
    </form>

</div>
